var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNewCloudIconInlineIntegration = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 90 90",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 90,
  rx: 24,
  fill: "#0077FF"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.4654 66.9706C19.0603 66.5328 14 61.1832 14 54.6481C14 48.3507 18.699 43.1541 24.7723 42.3927C24.67 41.594 24.6172 40.7797 24.6172 39.9531C24.6172 29.4856 33.0779 21 43.5148 21C52.7386 21 60.4189 27.6277 62.0796 36.3939C69.8823 37.0876 76 43.6603 76 51.6662C76 59.9917 69.3839 66.7674 61.1372 66.9932V67.0003H25.4654V66.9706Z",
  fill: "white"
})));
export { SvgNewCloudIconInlineIntegration as ReactComponent };